import { TaskButton } from './types'

export const STATUS_MAPPING: Record<string, TaskButton[]> = {
  '2': [
    {
      label: 'transport-order-card.assume',
      type: 'primary'
    }
  ],
  '3': [
    {
      label: 'transport-order-card.start',
      type: 'primary'
    },
    {
      label: 'transport-order-card.return',
      type: 'secondary'
    }
  ]
}
